exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pins-holder[data-v-9a50058e] {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n.pins-holder .positioned-pin[data-v-9a50058e] {\n    position: absolute;\n    margin: auto;\n    background-color: aqua;\n    border-radius: 50px;\n    width: 30px;\n    height: 30px;\n    text-align: center;\n    line-height: 30px;\n    transform: translate(-50%, -50%) scale(1);\n    opacity: 1;\n    transform-origin: center center;\n    transition: opacity ease-in-out 100ms;\n}\n.pins-holder .positioned-pin.is-currently-hovered[data-v-9a50058e] {\n      transform: translate(-50%, -50%) scale(1.3);\n}\n", ""]);

// exports
